<template>
  <Teleport to="body">
    <Transition name="modal-slide">
      <div v-if="modelValue" class="fixed inset-0 z-[999] flex items-center justify-center p-6">
        <div class="absolute inset-0 bg-black/20 backdrop-blur-sm" @click="close"></div>

        <div
          class="relative w-full max-w-2xl bg-white rounded-[2.5rem] shadow-[0_40px_80px_-15px_rgba(0,0,0,0.12)] border border-white/20 overflow-hidden transform transition-all">

          <div class="absolute top-3 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-gray-100 rounded-full"></div>

          <div class="px-10 pt-10 pb-4">
            <slot name="header">
              <div class="flex justify-between items-center">
                <div class="flex flex-col gap-1">
                  <span class="text-[10px] font-black text-[#1E90FF] uppercase tracking-[0.4em]">System Prompt</span>
                  <h3 class="text-xl font-bold text-gray-700 tracking-tight">{{ title }}</h3>
                </div>
                <button @click="close" class="p-2 text-gray-300 hover:text-red-400 transition-colors">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    <path d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </slot>
          </div>

          <div class="px-10 py-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
            <slot></slot>
          </div>

          <div class="px-10 py-8">
            <slot name="footer">
              <div class="flex gap-3">
                <button @click="close"
                  class="flex-1 py-4 text-xs font-bold text-gray-400 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-all uppercase tracking-widest">
                  Cancel
                </button>
                <button @click="$emit('confirm')"
                  class="flex-[1.5] py-4 bg-[#1E90FF] text-white text-xs font-black rounded-2xl shadow-lg shadow-blue-100 active:scale-95 transition-all uppercase tracking-[0.2em]">
                  {{ confirmText }}
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
/* eslint-disable */
const props = defineProps({
  modelValue: Boolean,
  title: { type: String, default: 'Notification' },
  confirmText: { type: String, default: 'Confirm' },
});
const emit = defineEmits(['update:modelValue', 'confirm']);
const close = () => emit('update:modelValue', false);
</script>

<style scoped>
/* 延续 SideDrawer 的平滑升起动画 */
.modal-slide-enter-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.7, 0, 0.84, 0);
}

.modal-slide-enter-from {
  opacity: 0;
  transform: translateY(100px) scale(0.9);
}

.modal-slide-leave-to {
  opacity: 0;
  transform: translateY(40px) scale(0.95);
}

/* 内部滚动条美化 */
.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #1E90FF;
}
</style>
